var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheck3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "check3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 54.207,
    height: 34,
    viewBox: "0 0 54.207 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_4925",
    "data-name": "\\uC0AC\\uAC01\\uD615 4925",
    width: 54.207,
    height: 34,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56520",
    "data-name": "\\uADF8\\uB8F9 56520",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33970",
    "data-name": "\\uD328\\uC2A4 33970",
    d: "M10.332,25.283a2.485,2.485,0,1,0,2.486,2.486,2.488,2.488,0,0,0-2.486-2.486m0,3.517a1.031,1.031,0,1,1,1.03-1.031,1.033,1.033,0,0,1-1.03,1.031",
    transform: "translate(0.067 0.215)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33971",
    "data-name": "\\uD328\\uC2A4 33971",
    d: "M43.461,25.283a2.485,2.485,0,1,0,2.486,2.486,2.488,2.488,0,0,0-2.486-2.486m0,3.517a1.031,1.031,0,1,1,1.031-1.031A1.033,1.033,0,0,1,43.461,28.8",
    transform: "translate(0.348 0.215)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33972",
    "data-name": "\\uD328\\uC2A4 33972",
    d: "M54.121,13.574,47.708,1.549A2.915,2.915,0,0,0,45.13,0H2.926A2.936,2.936,0,0,0,0,2.927V25.786a2.933,2.933,0,0,0,2.926,2.925H4.44l.018.13a6,6,0,0,0,6.784,5.1,6.033,6.033,0,0,0,5.1-5.1l.018-.13H37.849l.018.13a6,6,0,0,0,6.784,5.1,6.031,6.031,0,0,0,5.1-5.1l.019-.13h1.513a2.931,2.931,0,0,0,2.925-2.925V13.917a.71.71,0,0,0-.084-.343Zm-6.236-8.6.043.08,4.34,8.135H39.257V4.973ZM1.456,2.926a1.473,1.473,0,0,1,1.47-1.47H45.133a1.465,1.465,0,0,1,1.295.778l.683,1.284H38.533a.727.727,0,0,0-.727.727v9.672a.728.728,0,0,0,.727.728h14.22V16.7H50.843A2.5,2.5,0,0,0,48.5,18.362l-.035.1H5.744l-.035-.1A2.5,2.5,0,0,0,3.365,16.7H1.456v-2.06H8.641a.729.729,0,0,0,.728-.728V4.244a.728.728,0,0,0-.728-.727H1.456Zm0,2.047H7.909v8.215H1.454Zm1.91,13.188a1.031,1.031,0,0,1,0,2.062H1.456l0-2.062ZM10.4,32.532h0a4.547,4.547,0,1,1,4.547-4.548A4.553,4.553,0,0,1,10.4,32.532m33.409,0h0a4.547,4.547,0,1,1,4.548-4.548,4.553,4.553,0,0,1-4.548,4.548m8.943-6.746a1.477,1.477,0,0,1-1.47,1.47H49.769l-.019-.13a6,6,0,0,0-11.882,0l-.018.13H16.358l-.018-.13a6,6,0,0,0-11.882,0l-.018.13H2.926a1.474,1.474,0,0,1-1.47-1.47v-4.1h1.91a2.5,2.5,0,0,0,2.344-1.657l.035-.1h42.72l.035.1a2.493,2.493,0,0,0,2.343,1.657h1.911Zm0-5.564H50.843a1.031,1.031,0,0,1,0-2.062h1.911Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33973",
    "data-name": "\\uD328\\uC2A4 33973",
    d: "M14.061,14.615h9.672a.729.729,0,0,0,.727-.728V4.214a.728.728,0,0,0-.727-.727H14.061a.728.728,0,0,0-.728.727v9.672a.729.729,0,0,0,.728.728m.728-9.671H23v8.215H14.789Z",
    transform: "translate(0.113 0.03)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck3);
export default __webpack_public_path__ + "static/media/check3.20730ac4b0b2fe366f23060a40a49e25.svg";
export { ForwardRef as ReactComponent };